import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Trans } from "@lingui/macro";
import {
  ArrowDropdownDown,
  CheckSingle,
  ActionHeading,
  ActionItemButton,
  ActionList,
  Menu,
  Button,
  Popover,
} from "@conserveit/blocks";

import { setLocale } from "../../redux/modules/_BETA/selections";
import { locales } from "../../i18n";

function mapStateToProps(state) {
  return {
    locale: state.betaSelections.locale,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectLocale: (localeKey, cb) => () => {
      dispatch(setLocale(localeKey));
      cb();
    },
  };
}

const LanguageSelect = ({ locale, selectLocale }) => (
  <Menu>
    {({ isOpen, toggle, close }) => (
      <Fragment>
        <Button
          appearance="plain"
          thin
          onClick={toggle}
          data-cy="LanguageSelect"
        >
          {locales[locale]} <ArrowDropdownDown tiny />
        </Button>

        {isOpen && (
          <Popover>
            <ActionHeading>
              <Trans id="language_select.language">Language</Trans>
            </ActionHeading>
            <ActionList data-cy="LanguageSelect-options">
              {Object.entries(locales).map(([key, val]) => (
                <ActionItemButton
                  key={val}
                  onClick={selectLocale(key, close)}
                  renderAfter={locales[locale] === val && <CheckSingle tiny />}
                >
                  {val}
                </ActionItemButton>
              ))}
            </ActionList>
          </Popover>
        )}
      </Fragment>
    )}
  </Menu>
);

LanguageSelect.propTypes = {
  locale: PropTypes.string.isRequired,
  selectLocale: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);
